import wujiFetch from '@/utils/wujiFetch';
import { designPath } from '@config/constant';
import getXyManagePathPrefix from '@utils/getXyManagePathPrefix';

const fetchCollection = async ({ projectId, collectionId }) => await wujiFetch(`${getXyManagePathPrefix()}/datasource/collection/${collectionId}?projectid=${projectId}`);

const getAllCollection = async (projectId, filter = '', pathOpts) => {
  const res = await wujiFetch(`${getXyManagePathPrefix(pathOpts)}/datasource/basic/collection`, {
    method: 'get',
    query: {
      projectid: projectId,
      size: 'total',
      filter,
      sort: '_mtime',
      order: 'desc',
    },
  });
  return res;
};

// 获取详细版本的
const getAllDetailedCollection = async (projectId, filter = '', include = '') => {
  const res = await wujiFetch(`${getXyManagePathPrefix()}/datasource/collection`, {
    method: 'get',
    query: {
      projectid: projectId,
      size: 'total',
      filter,
      include,
      sort: '_ctime',
      order: 'desc',
    },
  });
  return res;
};

const createCollection = async (projectId, data = {}) => await wujiFetch(`${getXyManagePathPrefix()}/datasource/collection`, {
  method: 'post',
  body: JSON.stringify(data),
  query: {
    projectid: projectId,
  },
});

const updateCollection = async (projectId, data = {}, headers = {}) => {
  const res = await wujiFetch(`${getXyManagePathPrefix()}/datasource/collection/patch/${data.collectionId}`, {
    method: 'post',
    body: JSON.stringify(data),
    query: {
      projectid: projectId,
    },
    headers,
  });
  return res;
};

const getAllCollectionTag = async (projectId, filter = '') => await wujiFetch(`${designPath}/datasource/collection/tag`, {
  method: 'get',
  query: {
    projectid: projectId,
    size: 'total',
    filter,
  },
});

const createCollectionTag = async (projectId, data = {}) => await wujiFetch(`${designPath}/datasource/collection/tag`, {
  method: 'post',
  body: JSON.stringify(data),
  query: {
    projectid: projectId,
  },
});

const copyCollection = async (projectId, data = {}) => await wujiFetch(`${getXyManagePathPrefix()}/datasource/collection/copy`, {
  method: 'post',
  body: JSON.stringify(data),
  query: {
    projectid: projectId,
  },
});

const deleteCollection = async (projectId, collectionId) => await wujiFetch(`${getXyManagePathPrefix()}/datasource/collection/delete/${collectionId}`, {
  method: 'post',
  query: {
    projectid: projectId,
  },
});

// 获取项目下所有 CGI 插件列表
const fetchCgiPluginList = async projectId => await wujiFetch(`${getXyManagePathPrefix()}/datasource/cgi_plugin/`, {
  method: 'get',
  query: {
    projectid: projectId,
  },
});

// 获取单个 CGI 插件详情
const fetchCgiPlugin = async (projectId, pluginId) => await wujiFetch(`${getXyManagePathPrefix()}/datasource/cgi_plugin/${pluginId}`, {
  method: 'get',
  query: {
    projectid: projectId,
  },
});

export default {
  fetchCollection,
  getAllCollection,
  getAllDetailedCollection,
  createCollection,
  updateCollection,
  getAllCollectionTag,
  createCollectionTag,
  copyCollection,
  deleteCollection,
  fetchCgiPluginList,
  fetchCgiPlugin,
};
